import { motion } from "framer-motion";
import { RESONANCE_WORDS } from "../../data/homeContent";

const Row = ({ reverse, duration }) => {
  const doubled = [...RESONANCE_WORDS, ...RESONANCE_WORDS];
  return (
    <div className="overflow-hidden">
      <motion.div
        className="flex items-center gap-8 w-max"
        animate={{ x: reverse ? ["-50%", "0%"] : ["0%", "-50%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity }}
      >
        {doubled.map((w, i) => (
          <span key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-display text-base md:text-xl tracking-[0.16em] text-cream/40 whitespace-nowrap">{w}</span>
            <span className="w-1 h-1 rounded-full bg-[#C9A24B]/40" />
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export const ResonanceRibbon = () => {
  return (
    <section data-testid="resonance-ribbon" className="relative py-6 md:py-7 overflow-hidden">
      <div className="absolute left-0 top-0 bottom-0 w-28 z-10 bg-gradient-to-r from-[#05070C] to-transparent pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-28 z-10 bg-gradient-to-l from-[#05070C] to-transparent pointer-events-none" />
      <p className="text-center text-[10px] tracking-[0.34em] uppercase text-[#E7CC86]/45 mb-4">What this work is made of</p>
      <Row duration={70} />
    </section>
  );
};
